<mat-card>
    <mat-card-content>
        <p-table
            stripedRows
            [value]="items()"
            [loading]="loading()"
            [paginator]="totalCount() > tableRowDefault"
            [totalRecords]="totalCount()"
            [rows]="tableRowDefault"
            [rowsPerPageOptions]="tableRowsOptions"
            [paginatorLocale]="(locale$ | async)!"
            [showCurrentPageReport]="true"
            [currentPageReportTemplate]="tableCurrentPageReportTemplate()"
            [columns]="columns"
            [resizableColumns]="true"
            [lazy]="true"
            (onLazyLoad)="queryData.emit($event)"
            paginatorDropdownAppendTo="body"
            columnResizeMode="expand"
            sortMode="multiple">
            <ng-template #header>
                <tr class="table-headers">
                    @for (col of columns; track col.field) {
                        <th
                            [pSortableColumn]="col.field"
                            [pSortableColumnDisabled]="!col.sort"
                            pResizableColumn
                            title="{{ col.label | translate }}"
                            scope="col">
                            <div class="p-table-sort-header">
                                {{ col.label | translate }}
                                @if (col?.sort) {
                                    <p-sortIcon
                                        field="{{ col.field }}"
                                        class="flex items-center"></p-sortIcon>
                                }
                            </div>
                        </th>
                    }
                </tr>
            </ng-template>
            <ng-template #body let-item>
                <tr
                    class="cursor-pointer"
                    (click)="emailLogDetail.emit(item.logId)">
                    <td [title]="item.recipientEmail">
                        {{ item.recipientEmail }}
                    </td>
                    <td [title]="item.senderEmail">
                        {{ item.senderEmail }}
                    </td>
                    <td [title]="item.sentAtUrc">
                        {{ item.sentAtUtc | translateDate: 'medium' }}
                    </td>
                    <td [title]="item.subject">
                        {{ item.subject }}
                    </td>
                </tr>
            </ng-template>
            <ng-template #emptymessage>
                <apcam-primeng-no-records
                    class="table-row"
                    [colSpan]="columns.length"
                    [noLoadedData]="items().length === 0" />
            </ng-template>
        </p-table>
    </mat-card-content>
</mat-card>
